<template>
  <ECharts :autoresize="true" :options="options"></ECharts>
</template>

<script>
import ECharts from 'vue-echarts/components/ECharts.vue';
import 'echarts/lib/chart/pie';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
// import 'echarts/lib/component/dataset';
import 'echarts/lib/component/legend';

export default {
  components: {
    ECharts,
  },
  data() {
    return {
      options: {},
    };
  },
  props: {
    hdata: {
      type: Object || Array,
      default: () => ({}),
    },
    title: {
      type: String,
      default: '',
    },
    color: {
      type: Array,
      default: () => ['#17BC9A', '#EBF5F7'],
    },
  },
  watch: {
    hdata() {
      if (this.hdata) {
        this.getInit();
      }
    },
  },
  created() {
    this.getInit();
  },
  methods: {
    // 获取X轴Y轴的数据
    getInit() {
      let data = [];
      if (this.hdata) {
        data = [
          { name: '在线', value: this.hdata.On ? this.hdata.On : 0 },
          { name: '离线', value: this.hdata.Off ? this.hdata.Off : 0 },
        ];
      }
      let a = 0;
      for (let i = 0; i < data.length; i++) {
        a += data[i].value;
      }
      const opt = {
        title: {
          text: this.title,
          x: 'center',
          top: 10,
          textStyle: {
            fontWeight: 'normal',
            fontSize: 16,
          },
          subtext: [`{value|${a}}`, '{name|总数}'].join('\n'),
          subtextStyle: {
            rich: {
              value: {
                color: this.color && this.color.length ? this.color[0] : '',
                fontSize: 20,
                fontWeight: 'bold',
                lineHeight: 20,
              },
              name: {
                color: '#909399',
                lineHeight: 20,
              },
            },
          },
          itemGap: 80,
        },
        legend: {
          orient: 'vertical',
          y: 'bottom',
          x: 'center',
          data: [
          // name和下面的series中data的name对应显示。后面加textStyle可设置图例后面文字的颜色
            { name: '在线', textStyle: { color: '#B3BDC6' } },
            { name: '离线', textStyle: { color: '#B3BDC6' } },
          ],
          /* 图例旁边显示数据 */
          formatter(name) {
            let legendIndex = 0;
            const labels = [
              { name: '在线', textStyle: { color: '#B3BDC6' } },
              { name: '离线', textStyle: { color: '#B3BDC6' } },
            ];
            labels.forEach((value, i) => {
              if (value.name === name) {
                legendIndex = i;
              }
            });
            return `${name}: ${data[legendIndex].value}`;
          },
        },
        tooltip: {
          trigger: 'item',
          formatter(param) {
            let str = '<style>td{padding:5px;}</style><table>';
            let c = (param.value / a) * 100;
            c = c.toFixed(1);
            str = `${param.data.name}: ${str + c}%`;
            return str;
          },
        },
        series: [
          {
            type: 'pie',
            radius: ['60%', '70%'],
            center: ['50%', '50%'],
            data,
            label: { show: false },
          },
        ],
        color: this.color,
      };
      this.options = opt;
    },
  },
};
</script>

<style scoped>
.echarts {
  width: 100%;
  height: 100%;
}
</style>
